/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventContent
 */
export interface EventContent {
    /**
     * 
     * @type {string}
     * @memberof EventContent
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof EventContent
     */
    value?: string;
}

/**
 * Check if a given object implements the EventContent interface.
 */
export function instanceOfEventContent(value: object): value is EventContent {
    return true;
}

export function EventContentFromJSON(json: any): EventContent {
    return EventContentFromJSONTyped(json, false);
}

export function EventContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventContent {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'] == null ? undefined : json['key'],
        'value': json['value'] == null ? undefined : json['value'],
    };
}

export function EventContentToJSON(json: any): EventContent {
    return EventContentToJSONTyped(json, false);
}

export function EventContentToJSONTyped(value?: EventContent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}

